import { Component, OnInit } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoginResponseData } from 'src/app/interfaces/LoginResponseData';
import { Observable, finalize, from, map } from 'rxjs';
import { DataFunctions } from 'src/app/tools/data-functions';
import { PasswordChangeFormComponent } from '../../../shared/password-change-form/password-change-form.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
  imports: [CommonModule, PasswordChangeFormComponent],
})
export class ChangePasswordComponent implements OnInit {
  error!: string | null;
  success: any;
  status: any;
  passwordRecovery: boolean = false;
  recoveryToken: string = '';
  preSurveyState = false;
  changePasswordAtLogin: boolean = false;
  oldPassword: string = '';
  checksLoaded: boolean = false;

  constructor(
    private _location: Location,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    //see if we have a recovery token and if we do, set password recovery to true
    this.route.params.subscribe((params) => {
      this.recoveryToken = DataFunctions.nvl(params['recoveryToken']);
      if (this.recoveryToken.length > 0) {
        this.passwordRecovery = true;
      }
    });

    this.authService.oldPassword.subscribe(
      (oldPassword) => {
        this.changePasswordAtLogin = true;
        this.oldPassword = oldPassword;
        this.checksLoaded = true;
      },
      (error) => {
        this.checksLoaded = true;
      },
    );
  }

  ngOnInit(): void {
    this.authService.getStatus();
    this.authService.checkStatus().subscribe((loginResponseData) => {
      if (loginResponseData.status == 2) {
        this.preSurveyState = true;
      }
    });
  }

  passwordChanged(event: any) { }
}
